import type { Store } from 'src/store/types';

import {
  selectReadyToSendAnalytics,
  selectAnalyticsGlobals,
} from '../selectors';

// Tracks that a page has been viewed once page information is available
export const trackPageView = (
  store: Store,
  trackView: (eventName: string, props: any) => void,
  eventName: string,
  props = {},
) => {
  let hasSent = false;

  function attemptSend() {
    // Ensure a single view is never sent twice
    if (hasSent) {
      store.unsubscribe(attemptSend);
      return true;
    }
    const isReadyToSendView = selectReadyToSendAnalytics(store.getState());

    if (isReadyToSendView) {
      store.unsubscribe(attemptSend);
      hasSent = true;
      trackView(eventName, {
        ...selectAnalyticsGlobals(store.getState()),
        ...props,
      });
      return true;
    }
    return false;
  }

  if (!attemptSend()) {
    store.subscribe(attemptSend);
  }
};
